import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  mileageTab: {
    //
  }
});

export default styles;
